import React from 'react'

const tleft = ({Title, Message, Image, Class}) => {
    
    return (
        <div className={Class}>
            <div className='textImage_wrappper '>
                <div className='textImage_col'>
                    <div className='textImage_text'>
                        <h3>{Title}</h3>
                        {
                            Message.map((object, i) => {
                                return (<p key={i}> {object} </p>)
                            })
                        }
                    </div>
                </div>
                <div className='textImage_col'>
                    <div className='textImage_img'>
                        <img src={Image} alt='some' />
                    </div>
                </div>
            </div>
        </div>
  )
}

export default tleft
